<template>
  <a-modal
    :visible="visible"
    title="导入配方"
    :width="1000"
    :maskClosable="false"
    :confirmLoading="loading"
    :okText="'确定'"
    :cancelText="'取消'"
    :okButtonProps="{ disabled: selectedCount === 0 }"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="import-formula-container">
      <!-- 搜索区域 -->
      <div class="search-section">
        <div class="search-item">
          <span class="label">配方分类:</span>
          <a-select
            v-model="searchForm.typeClassify"
            placeholder="请选择分类"
            allowClear
            style="width: 150px"
          >
            <a-select-option :value="0">未分类</a-select-option>
            <a-select-option :value="1">自产配方</a-select-option>
            <a-select-option :value="2">代工配方</a-select-option>
            <a-select-option :value="3">定制配方</a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <span class="label">配方名称/配方代码:</span>
          <a-input
            v-model="searchForm.keyword"
            placeholder="请输入配方名称或配方代码"
            allowClear
            style="width: 250px"
            @pressEnter="handleSearch"
          />
          <a-button type="primary" @click="handleSearch" style="margin-left: 8px">
            查询
          </a-button>
        </div>
      </div>

      <!-- 表格区域 -->
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="tableLoading"
        :pagination="pagination"
        :rowSelection="rowSelection"
        :rowKey="getRowKeyFn"
        size="small"
        @change="handleTableChange"
      >
      </a-table>

      <!-- 底部选中信息 -->
      <div class="footer-info">
        <span style="font-size: 12px" v-if="selectedCount">已选中 {{ selectedCount }}个配方</span>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { post } from '@/Utils/axios'

export default {
  name: 'ImportFormula',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentFormulaId: {
      type: [String, Number],
      default: ''
    },
    existingCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      tableLoading: false,
      searchForm: {
        typeClassify: undefined,
        keyword: ''
      },
      selectedRowKeys: [],
      dataSource: [],
      columns: [
        {
          title: '配方代码',
          dataIndex: 'formulaCode',
          key: 'formulaCode',
          width: 150
        },
        {
          title: '配方名称',
          dataIndex: 'formulaName',
          key: 'formulaName',
          width: 200
        },
        {
          title: '动物类型',
          dataIndex: 'animalTypeName',
          key: 'animalTypeName',
          width: 150
        },
        {
          title: '工厂名称',
          dataIndex: 'factoryName',
          key: 'factoryName',
          width: 150
        },
        {
          title: '用户名称',
          dataIndex: 'createUserName',
          key: 'createUserName',
          width: 120
        }
      ],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共${total}条记录`,
        pageSizeOptions: ['10', '20', '50', '100']
      }
    }
  },
  computed: {
    selectedCount() {
      return this.selectedRowKeys.length
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initSearch()
      }
    }
  },
  methods: {
    getRowKeyFn(record, index) {
      return record.id ? String(record.id) : `row-${index}`
    },

    initSearch() {
      this.selectedRowKeys = []
      this.searchForm = {
        typeClassify: undefined,
        keyword: ''
      }
      this.pagination.current = 1
      this.loadFormulaList()
    },

    handleSearch() {
      this.pagination.current = 1
      this.loadFormulaList()
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    async loadFormulaList() {
      this.tableLoading = true
      try {
        // 获取工厂ID和员工ID
        const factoryId = window.localStorage.getItem('factoryId')
        const staffId = window.localStorage.getItem('staffId')
        
        // 配方类型：0=未分类, 1=自产配方, 2=代工配方, 3=定制配方
        const typeClassify = this.searchForm.typeClassify
        
        const params = {
          id: this.currentFormulaId,
          factoryId: factoryId,
          staffId: staffId,
          status: 0,
          formulaType :1,
          ...(typeClassify !== undefined && { typeClassify }),
          ...(this.searchForm.keyword && { formulaKeyword: this.searchForm.keyword }),
          query: {
            current: this.pagination.current,
            size: this.pagination.pageSize
          }
        }
        const res = await post('/nhf-app/formulaManage/getFormulaNotInBagPage', params)
        
        if (res) {
          if (res.records) {
            this.dataSource = res.records || []
            this.pagination.total = res.total || 0
          } else if (Array.isArray(res)) {
            this.dataSource = res
            this.pagination.total = res.length
          } else if (res.data) {
            if (Array.isArray(res.data)) {
              this.dataSource = res.data
              this.pagination.total = res.data.length
            } else if (res.data.records) {
              this.dataSource = res.data.records || []
              this.pagination.total = res.data.total || 0
            }
          } else {
            this.dataSource = []
            this.pagination.total = 0
          }
        }
      } catch (error) {
        this.$message.error('加载配方列表失败')
        this.dataSource = []
        this.pagination.total = 0
      } finally {
        this.tableLoading = false
      }
    },

    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadFormulaList()
    },

    async handleOk() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请至少选择一个配方')
        return
      }

      // 验证总数量不超过5个
      const totalCount = this.existingCount + this.selectedRowKeys.length
      if (totalCount > 5) {
        this.$message.warning(`配方组合包中配方数量不能超过5个，当前已有${this.existingCount}个，最多还可添加${5 - this.existingCount}个`)
        return
      }

      this.loading = true
      try {
        // 调用导入接口
        const factoryId = window.localStorage.getItem('factoryId')
        const params = {
          bagFormulaIdList: this.selectedRowKeys,
          formulaId: this.currentFormulaId,
          factoryId: factoryId
        }
        const res = await post('/nhf-app/formulabag/addFormulaBag', params)
        
        if (res) {
          this.$message.success('导入成功')
          this.$emit('success')
          this.handleCancel()
        }
      } catch (error) {
        this.$message.error('导入失败，请重试')
      } finally {
        this.loading = false
      }
    },

    handleCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.import-formula-container {
  .search-section {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;

    .search-item {
      display: flex;
      align-items: center;
      gap: 8px;

      .label {
        font-size: 14px;
        color: #333;
        white-space: nowrap;
      }
    }
  }

  .footer-info {
    padding: 10px 15px 0;
    margin: 10px -10px 0;
    border-top: 1px solid #eee;
  }
}

::v-deep .ant-table-thead > tr > th {
  background-color: #fafafa;
  font-weight: 600;
}

::v-deep .ant-table-tbody > tr > td {
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .ant-pagination {
  margin-top: 16px;
  margin-bottom: 0;
}
</style>

